<template>
    <div class="dialog-warp loginWrap">
        <div class="login-logo">
            <img src="@/assets/login/login_bg.png">
        </div>
        <div class="email-wrap">
            <div class="welcome">Hi! Welcome to Black Gemstone</div>
        </div>
        <div class="email-input">
            <div>
                <el-input v-model.trim="account" placeholder="email account"></el-input>
                <el-input
                ref="passwordInput"
                :type="showPassword ? 'text' : 'password'"
                class="mt10"
                v-model.trim="password"
                placeholder="Password"
                >
                    <template #suffix>
                        <i
                        class="el-icon-view"
                        :style="{ cursor: 'pointer' }"
                        @click="togglePassword"
                        ></i>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="email-submit">
            <el-checkbox v-model="radio" label="1">
                <span>Agree to the </span>
                <router-link to="/privacy">Terms of Service</router-link>
                <span> and </span>
                <router-link to="/userAgree">Privacy Policy</router-link>
            </el-checkbox>
            <el-button round class="create-btn f16 font-MT mt20" size="medium" @click="toLogin" v-preventReClick>Login now</el-button>
            <div class="go-register" @click="goRegister">Go to Register</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EmailLogin',
    data() {
        return {
            account: '',
            password: '',
            radio: false,
            showPassword: false,
            selection: { start: 0, end: 0 },
        };
    },
    mounted() {
        
    },
    methods: {
        toLogin() {
            if (!this.radio) {
                this.$message.error(this.$lang('tips.agreement'));
                return;
            };
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
            if (this.account == '') {
                this.$message.error(this.$lang('tips.cannotBeEmpty'));
                return;
            };

            if (!emailRegex.test(this.account)) {
                this.$message.error(this.$lang('tips.format'));
                return;
            };
            if (this.password === '') {
                this.$message.error(this.$lang('tips.inputPassword'));
                return;
            };
            this.$emit('email-login', {account: this.account, password: this.password});
        },
        togglePassword() {
            const input = this.$refs.passwordInput.$el.querySelector("input");
            this.selection = {
                start: input.selectionStart,
                end: input.selectionEnd,
            };
            this.showPassword = !this.showPassword;
            this.$nextTick(() => {
                input.setSelectionRange(this.selection.start, this.selection.end);
                input.focus();
            });
        },
        goRegister() {
            this.$emit('update-index', 3);
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-input__suffix{
    display: flex;
    align-items: center;
    right: 10px;
}
.loginWrap{
    padding-bottom: 20px !important;
    .login-logo{
        position: absolute;
        left: 50%;
        top: -50px;
        transform: translateX(-50%);
        >img{
            width: 246px;
            height: 150px;
        }
    }
    .email-wrap{
       margin-top: 100px;
       .welcome{
            font-family: 'PingFangSC';
            text-align: center;
            font-size: 18px;
            color: #666;
            margin-bottom: 30px;
        }
    }
    .email-input{
        width: 360px;
        margin: 40px auto;
    }
    .email-submit{
        margin: 0 auto;
        width: 360px;
        display: flex;
        flex-direction: column;
        /deep/.el-checkbox{
            font-family: 'AlimamaFangYuanTiVF';
            font-weight: 400;
            font-size: 12px;
            color: #666;
            line-height: 31px;
            .el-checkbox__input.is-checked+.el-checkbox__label{
                color: #666 !important;
            }
            .el-checkbox__label{
                >a{
                    color: #666;
                    text-decoration: underline;
                }
            }
            .el-checkbox__input.is-checked .el-checkbox__inner::after {
                content: "";
                width: 10px;
                height: 10px;
                background: #FF049B;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                border: none;
            }
            .el-checkbox__input{
                &.is-checked{
                    .el-checkbox__inner{
                        background: transparent;
                        border-color: #FF049B;
                        &:hover{
                            border-color: #FF049B;
                        }
                    }
                }
                &.is-focus{
                    .el-checkbox__inner{
                        border-color: #FF049B;
                    }
                }
                .el-checkbox__inner{
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    &:hover{
                        border-color: #DCDFE6;
                    }
                }
            }
        }
        .el-button{
            width: 100%;
        }
        .go-register{
            margin-top: 10px;
            text-align: center;
            font-family: 'AlimamaFangYuanTiVF';
            font-size: 12px;
            color: #666666;
            line-height: 31px;
        }
    }
}
</style>